<script>
import Layout from '@layouts/default'

export default {
  page: {
    title: 'Free Online Vehicle History Report Delivery | AutoCheck.com',
    meta: [
      {
        name: 'description',
        content: 'Free Online Vehicle History Report Delivery',
      },
      {
        name: 'keywords',
        content: 'Free Online Vehicle History Report Delivery',
      },
    ],
    link: [
      {
        rel: 'canonical',
        href: 'https://www.autocheck.com/vehiclehistory/free-online-delivery',
      },
    ],
  },
  components: { Layout },
}
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-12 mt-4 mb-4">
        <h1>Free Online Vehicle History Report Delivery</h1>
        <hr />
        <p
          >When you subscribe to AutoCheck® vehicle history reports your reports
          are immediately available to you via your
          <BaseLink :to="{ name: 'dashboard' }"
            >password protected VHR dashboard</BaseLink
          >, accessible from your desktop computer or mobile device, and remain
          available online for the full term of your subscription.</p
        >
        <p
          >To secure a time-stamped, hard copy of your report simply print your
          AutoCheck vehicle history report to your local printer. VHRs print as
          PDFs, which means you will need to have
          <a
            target="_blank"
            class="secondary-anchor-link"
            href="http://get.adobe.com/reader/"
            >Adobe Acrobat Reader</a
          >
          installed. (<a
            target="_blank"
            class="secondary-anchor-link"
            href="http://get.adobe.com/reader/"
            >download now: http://get.adobe.com/reader/</a
          >)</p
        >
        <p
          >Please keep in mind: Your VHR dashboard provides a live data view to
          all reported data for the associated vehicle. Because of this, the
          vehicle’s AutoCheck Score™ may also change over time as more data
          becomes available for a vehicle. We recommend checking your VHR
          dashboard prior to purchase of any pre-owned car for the most recent
          reported information available on that vehicle.</p
        >
      </div>
    </div>
  </Layout>
</template>

<style lang="scss" module>
@import '@design';
</style>
